<template>
  <div class="sidebar-user compact-style">
    <div class="user-main-row d-flex align-items-center justify-content-between w-100">
      <div class="user-info-col d-flex flex-column align-items-start">
        <router-link to="/users/profile" class="userName-link">
          <h6 class="userName-text">{{ userName }}</h6>
        </router-link>
        <span v-if="userRole" class="user-role-badge">{{ userRole }}</span>
      </div>
      <div class="logout-icon-btn" @click="handleLogout" title="Logout">
        <vue-feather type="log-out"></vue-feather>
      </div>
    </div>

    <div v-if="isCustomer" class="wallet-mini-card mt-2">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex flex-column">
          <span class="wallet-label">Số dư</span>
          <span class="balance-value">{{ userBalance }}</span>
        </div>
        <button class="btn-deposit-sm" @click="handleDeposit">Nạp tiền</button>
      </div>
    </div>
    <DepositModal :isOpen="isDepositModalOpen" @close="isDepositModalOpen = false" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useCurrentUser } from "@/composables/useCurrentUser";
import { useRouter } from 'vue-router';
import DepositModal from "@/components/payments/DepositModal.vue";

const { currentUser, loadCurrentUser, clearCurrentUser } = useCurrentUser();
const router = useRouter();

const isDepositModalOpen = ref(false);

const userName = computed(() => currentUser.value?.email || '...');
const userRole = computed(() => currentUser.value?.roles?.[0]?.display_name || currentUser.value?.roles?.[0]?.name || '');
const isCustomer = computed(() => currentUser.value?.roles?.some(role => role.name === 'customer'));
const userBalance = computed(() => {
  const balance = currentUser.value?.balance || 0;
  return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(balance);
});

const handleLogout = () => {
  clearCurrentUser();
  localStorage.removeItem('user');
  router.replace('/auth/login');
};

const handleDeposit = () => {
  isDepositModalOpen.value = true;
};

onMounted(() => {
  loadCurrentUser();
});
</script>

<style scoped>
.sidebar-user {
  padding: 10px 15px;
  background: #fff;
  border-bottom: 1px solid #f1f5f9;
}

.userName-text {
  font-size: 0.9rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role-badge {
  display: inline-block;
  font-size: 0.6rem;
  font-weight: 600;
  color: #7c3aed;
  background: #f5f3ff;
  padding: 0px 8px;
  border-radius: 4px;
}

.logout-icon-btn {
  cursor: pointer;
  color: #64748b;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logout-icon-btn:hover {
  background: #fef2f2;
  color: #ef4444;
}

.logout-icon-btn svg {
  width: 18px;
  height: 18px;
}

.wallet-mini-card {
  background: #f8fafc;
  border-radius: 8px;
  padding: 8px 12px;
  border: 1px solid #f1f5f9;
}

.wallet-label {
  font-size: 0.55rem;
  color: #64748b;
  text-transform: uppercase;
  font-weight: 700;
}

.balance-value {
  font-size: 0.85rem;
  font-weight: 700;
  color: #10b981;
}

.btn-deposit-sm {
  background: #10b981;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 0.65rem;
  font-weight: 600;
  cursor: pointer;
}

.btn-deposit-sm:hover {
  background: #059669;
}
</style>